import React from "react";
import styled from "styled-components";
import pix from "./p2.jpg";
import vid from "./fri.mp4";
import red from "./red.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const About = () => {
  return (
    <Container>
      <Wrapper>
        <Holder>
          <TextHeader>The Story of CodeLab</TextHeader>
          <TextHolder>
            <TextSub>
              A Software infrastructural training Program designed to arm young people with
              the skills and knowledge required to launch a career in Tech.
            </TextSub>
          </TextHolder>
          <LineHolder>
            <Line />
          </LineHolder>
        </Holder>

        <ImageHolder>
          <Video controls src={vid} />
        </ImageHolder>
        <hr />

        <Content>
          <ContentHeader>About Our curriculum</ContentHeader>
          <ContentPara>
          In every set of CodeLab's intake, we thrive to make the new session better (in training and in learning curve) than the previous...
For this: We are constantly improving on our curriculum and our teaching practice!
            <br />
            <br />
            
We share of a very strong opinion that, brilliance is evenly distributed: every part of the world has a share of theirs. Likewise, Rural Communities!<br />
            <br />
But the infrastructure that nurtures this brilliance: from Ideas to Product, from Blueprints to Building and from Experiment to Market, in rural Communities isn't evenly distributed and this has in so many ways, created great disparity between young people from the other side.
<br />
            <br />
For us at CodeLab, we are committed to creating software training infrastructure within these Rural communities, that would scout and train these brilliance for the numerious Opportunities scattered across the world. 
        
            <br />
            <br />
            One of our core drive, is to help young prople get started on the career they wanted in Tech.
            Whether you are fresh out of high school or a new college graduate, seeking extra education,
            or want to transition to a career in tech, We will give you the
            skills and insight to achieve the success you desire.
          </ContentPara>
        </Content>

        <Content>
          <ContentHeader1>
            <Design src={red} />
            <span> Why Codelab</span>
            <Design src={red} bg />
          </ContentHeader1>
          <ContentPara>
            <CPH>
              <CheckCircleIcon />
              <span>We are not all talk.</span>
            </CPH>
            <CPA>
              Our programs are a perfect blend of theory and practice, providing
              you with a well-rounded insight to get you on going!.
            </CPA>
          </ContentPara>
          <ContentPara>
            <CPH>
              <CheckCircleIcon />
              <span>
                Whatever your style of learning, we’ve got you covered.
              </span>
            </CPH>
            <CPA>
              Our blended learning approach allows for self-paced learning as
              well as instructor-led, real-time sessions and loads of practice.
            </CPA>
          </ContentPara>
          <ContentPara>
            <CPH>
              <CheckCircleIcon />
              <span>Experienced and Expert Instructors</span>
            </CPH>
            <CPA>
              Our faculty comprises of instructors who are not just
              knowledgeable but are industry leaders in their fields and able to
              teach industry best practices
            </CPA>
          </ContentPara>
          <ContentPara>
            <CPH>
              <CheckCircleIcon />
              <span>A 1 Year Practical Traning Program</span>
            </CPH>
            <CPA>
              We are not about wasting time. Our curriculum goes straight into
              the nitty-gritty and teaches up to date and usable skills and
              knowledge.
            </CPA>
          </ContentPara>
          <ContentPara>
            <CPH>
              <CheckCircleIcon />
              <span>Professional and Certification Exam, to be taken</span>
            </CPH>
            <CPA>
              At the end of the Program, you are encourage to partake on examinations that would give you better and wider Opportunities but bot to worries because we will hold you by hands in all the Exams.
            </CPA>
          </ContentPara>
        </Content>
      </Wrapper>
    </Container>
  );
};

export default About;

const Design = styled.img`
  object-fit: contain;
  display: flex;
  transform: ${({ bg }) => (bg ? "rotateY(180deg)" : "rotateY(0deg)")};

  @media screen and (max-width: 800px) {
    margin-bottom: 50px;
    width: 100%;
    display: none;
  }
`;
const CPA = styled.div``;
const CPH = styled.div`
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  margin-top: 30px;

  .MuiSvgIcon-root {
    font-size: 30px;
    color: #004080;
    margin-right: 20px;
  }

  @media screen and (max-width: 500px) {
    font-size: 21px;
    line-height: 1.2;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  padding-top: 50px;

  @media screen and (max-width: 500px) {
    padding-bottom: 20px;
    padding-top: 20px;
  }
`;
const ContentHeader1 = styled.div`
  font-size: 45px;
  font-weight: bold;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  text-align: center;

  @media screen and (max-width: 800px) {
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
  }
  @media screen and (max-width: 500px) {
    display: flex;
    justify-content: center;
    font-size: 30px;
    margin: 0 30px;
    width: 80%;
  }
`;
const ContentHeader = styled.div`
  font-size: 45px;
  font-weight: bold;
  margin-bottom: 30px;

  @media screen and (max-width: 800px) {
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 500px) {
    font-size: 25px;
    margin-bottom: 10px;
  }
`;

const ContentPara = styled.div`
  width: 60%;
  font-size: 25px;
  line-height: 1.5;

  @media screen and (max-width: 500px) {
    font-size: 20px;
    line-height: 1.5;
    width: 80%;
  }
`;

const ImageHolder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 500px) {
    padding-top: 0px;
  }
`;
const Video = styled.video`
  width: 80%;
  object-fit: cover;
  /* position: absolute; */
  margin-top: -250px;

  @media screen and (max-width: 500px) {
    margin-top: -300px;
  }
`;

const Holder = styled.div`
  padding-top: 200px;
  padding-bottom: 50px;
  color: white;
  background: black;
  display: flex;
  flex-direction: column;
  min-height: 500px;
  width: 100%;

  @media screen and (max-width: 500px) {
    padding-top: 120px;
  }
`;

const Line = styled.div`
  border: 0.5px solid lightgray;
  margin-top: 50px;
  width: 80%;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;

const LineHolder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const TextHolder = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;

  @media screen and (max-width: 500px) {
    margin-bottom: 20px;
  }
`;
const TextSub = styled.div`
  width: 80%;
  justify-content: center;
  display: flex;
  font-size: 30px;
  margin: 0 40px;
  text-align: center;

  @media screen and (max-width: 800px) {
    margin-bottom: 50px;
  }

  @media screen and (max-width: 500px) {
    font-size: 18px;
    margin-bottom: 20px;
    width: 90%;
    line-height: 1.3;
  }
`;
const TextHeader = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  font-size: 60px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;

  @media screen and (max-width: 500px) {
    font-size: 35px;
    padding-top: 20px;
  }
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
  min-height: 500px;
  background: #fef6ee;
  display: flex;
  justify-content: center;
`;
